import { Injectable } from '@angular/core';
import { ConfirmService } from '@tymes4-shared';
import { TranslateService } from '@ngx-translate/core';
import { EntranceCoverageResult } from '../api';

@Injectable()
export class EntranceCoverageHelper {

  constructor(private confirmService: ConfirmService, private translate: TranslateService) { }

  isCovered(coverage: EntranceCoverageResult): boolean {
    if (coverage?.Valid) {
      return true;
    }

    let sectionList = '';
    for (let name of coverage?.SectionsWithoutEntrance ?? []) {
      sectionList += `<li>${name}</li>`;
    }
    sectionList = '<ul>' + sectionList + '</ul>';

    let message = this.translate.instant('LOCATIONEDIT.MISSINGENTRANCES.MESSAGE');
    message = message.replace('[sectionlist]', sectionList);

    this.confirmService.confirm({
      title: this.translate.instant('LOCATIONEDIT.MISSINGENTRANCES.TITLE'),
      message: message,
      okonly: true
    }).subscribe();

    return false;
  }
}
